import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterAbility,
  AbilityEffect,
  SummonOption2,
  CharacterSheetInterface,
  CharacterSpell,
  Attack,
  ExtraEffectsFeature,
  CharacterFeature,
  ExtraEffectsOfTypeFeature,
  CharacterAction,
  CharacterExtraEffects,
  SpellInfusionExtraEffectsFeature,
  StoredSpell,
} from "@dndModels";
import { DamageType } from "@dndModels/Types";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
// import DataUtilities from '../../../utilities/common_utilities';

import DandDButtonBox from "@dndComponents/DandDButtonBox";

import CharacterSummonOptions from "@dndComponents/character/misc/CharacterSummonOptions";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import LoadingBox from "@components/input/LoadingBox";
import DisplaySummonOption from "@dndComponents/display/DisplaySummonOption";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
  spell?: CharacterAbility | CharacterSpell | StoredSpell;
  action: CharacterAction;
  effect: AbilityEffect;
  cee?: CharacterExtraEffects;
  processing: boolean;
  disabled: boolean;
  log_it?: boolean;
  ee_cf?: CharacterFeature;
  type_cf?: CharacterFeature;
  shared: boolean;
  level: number;
  wide: boolean;
  show_extra_effects?: boolean;
  attack_mod?: number;
  main_damage_type?: DamageType;
  casting_time: string; // 'A' | 'BA' | 'RA' | 'Special' | 'Attack' | "1 Minute" | "10 Minutes" | "1 Hour";
  onChange: (change_types: string[]) => void; // For slots, resources, and concentration
  onCostChange: (costs: { [resource: string]: number }) => void;
  hide_touch?: boolean;
  extra_string: string;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
// const common_util = DataUtilities.getInstance();

export default function CharacterSummonEffect({
  character,
  char_interface,
  spell,
  action,
  effect,
  cee,
  processing,
  disabled,
  ee_cf,
  shared,
  level,
  attack_mod = 0,
  main_damage_type,
  hide_touch = false,
  onChange,
  onCostChange,
  extra_string,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [is_processing, setProcessing] = useState(false);
  // const [ping, setPing] = useState(false);
  // const [keep_rolls, setKeepRolls] = useState<any[]>([]);
  const [summon_option_list, setSummonOptionList] = useState<SummonOption2[]>([]);
  const [selected_option, setSelectedOption] = useState<SummonOption2 | null>(null);
  // const [selected_id, setSelectedId] = useState("");
  const [open, setOpen] = useState(false);

   
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });

  useEffect(() => {
    if (is_processing !== processing) {
      setProcessing(processing);
    }
    // eslint-disable-next-line
  }, [processing]);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  const enabled = shared || (!disabled && api.user && (character.owner_id === api.user._id || (character.campaign !== null && character.campaign.owner_id === api.user._id)));
  const item_id = spell instanceof CharacterAbility ? spell.item_id : (spell instanceof CharacterSpell ? spell.source_true_id : "");
   
  // useEffect(() => {
  //   if (spell instanceof CharacterAbility && spell.the_ability) {
  //     const effect_type = effectType();
  //     const attack_stat = spell.spellcasting_ability;
  //     const potence = ee_cf && (ee_cf.floating_feature instanceof ExtraEffectsFeature || ee_cf.floating_feature instanceof SpellInfusionExtraEffectsFeature || ee_cf.floating_feature instanceof ExtraEffectsOfTypeFeature) ? 
  //       char_util.getPotence({slot_level: level, char: character, item_id, char_int: char_interface, spell: ee_cf, effect, cfs_id: (ee_cf ? ee_cf.source_id : ""), attack_mod, attack_stat }) 
  //       : spell ? 
  //       char_util.getPotence({slot_level: level, char: character, item_id, char_int: char_interface, spell, effect, cfs_id: "", attack_mod, attack_stat, action }) : null;
  //     if (potence) {
  //       if (effect_type === "Adaptation") {
  //         let filtered: Adaptation[] = []; // api.filter("", adaptations, potence.obj_filter);
  //         // if (potence.knowledge_usage_key.length > 0) {
  //         //   filtered = filtered.filter(o => 
  //         //     character.knowledge.filter(o2 => 
  //         //       o2.obj_id === o._id && 
  //         //       o2.type === "Adaptation" && 
  //         //       o2.usage === potence.knowledge_usage_key
  //         //     ).length > 0
  //         //   );
  //         // }
  //         const selected_adaptation = filtered.length === 1 ? filtered[0] : filtered.find(o => o._id === selected_id);
  //         if (selected_adaptation) {
  //           const costs: { [resource: string]: number } = {};
  //           costs[spell.the_ability.resource_consumed] = selected_adaptation.cost;
  //           onCostChange(costs);
  //         }
  //       }
  //     }
  //   }
  //   // eslint-disable-next-line
  // }, [selected_id, setSelectedId]);
      
  const load = () => {
    const potence = ee_cf && (ee_cf.floating_feature instanceof ExtraEffectsFeature || ee_cf.floating_feature instanceof SpellInfusionExtraEffectsFeature || ee_cf.floating_feature instanceof ExtraEffectsOfTypeFeature) ? 
      char_util.getPotence({ slot_level: level, char: character, item_id, char_int: char_interface, spell: ee_cf, effect, cfs_id: (ee_cf ? ee_cf.source_id : ""), attack_mod }) : 
      spell ? char_util.getPotence({ slot_level: level, char: character, item_id, char_int: char_interface, spell, effect, cfs_id: "", attack_mod, action }) : null;
    // let extra_string = "";
    if (potence) {
      // if (spell && spell.name.includes("Familiar")) {
      //   debugger;
      // }
      setLoading(true);
      // extra_string = potence.extra;
      char_util.getSummonOption2s(character, potence).then(options => {
        setSummonOptionList(options);
        setLoading(false);
      });
    }
    setFetched(true);
  }

  // const effectType = () => {
  //   // if (spell instanceof CharacterSpell && spell.name.includes("Vortex")) {
  //   //   debugger;
  //   // }
  //   let effect_type: EffectType | DamageType = effect.type;
  //   if (effect_type === "Damage" && spell instanceof CharacterSpell) {
  //     const dt_mods = spell.damage_type_modifications;
  //     if (dt_mods.length > 0) {
  //       return dt_mods[0].detail as DamageType;
  //     }
  //   }
  //   if (effect_type === "Selectable Key") {
  //     const key = effect.selectable_key;
  //     let cfs: CharacterFeatureSource | null = null;
  //     // console.log(key);
  //     // console.log(spell);
  //     if (spell && !(spell instanceof StoredSpell)) {
  //       switch (spell.source_type) {
  //         case "Race": cfs = character.race; break;
  //         default:
  //           console.log(spell);
  //           console.log(key);
  //           console.log(effect);
  //           console.log(character);
  //         break;
  //       }
  //     }
  //     // console.log(cfs);
  //     if (cfs) {
  //       // console.log(cfs.selectable_hash[key]);
  //       // console.log(effect.selectable_type);
  //       // console.log(EFFECT_TYPES);
  //       if (cfs.selectable_hash[key]) {
  //         const selected = cfs.selectable_hash[key][0];
  //         if (EFFECT_TYPES.includes(selected)) {
  //           effect_type = selected as EffectType;
  //         } else {
  //           if (effect.selectable_type === "Damage Type" && 
  //             ALL_DRAGONS.includes(selected)) {
  //             effect_type = (DRACONIC_DAMAGE_TYPES as any)[selected];
  //           }
  //         }
  //       }
  //     }
  //   } else if (effect_type === "Use Extra") {
  //     if (ee_cf) {
  //       const char_item = character.all_char_feature_sources.find(o => o.true_id === ee_cf.item_id);
  //       const cmik = character.all_char_feature_sources.find(o => o.true_id === ee_cf.source_true_id);
  //       if (char_item instanceof CharacterItem && cmik instanceof CharacterMagicItemKeyword) {
  //         if (cmik.source) {
  //           if (cmik.source.extra_base_type === "Dragon Breed") {
  //             effect_type = (DRACONIC_DAMAGE_TYPES as any)[char_item.extra];
  //           } else if (EFFECT_TYPES.includes(char_item.extra)) {
  //             effect_type = char_item.extra as EffectType;
  //           }
  //         }
  //       }
  //     }
  //   }
  //   if (effect_type === "Same as Main" && main_damage_type && main_damage_type !== "Typeless" && main_damage_type !== "Same as Main") {
  //     effect_type = main_damage_type;
  //   }
  //   return effect_type;
  // }

  const renderExtras = () => {
    return (
      <>
        <ModalOrDrawer
          open={open}
          onClose={() => { 
            setOpen(false); 
            character.subscription_holder.modalClosed();
          }}
        >
          <>
            { open && renderSummonOptions() }
          </>
        </ModalOrDrawer>
      </>
    );
  }

  const renderSummonOptions = () => {
    const option = summon_option_list.length === 1 ? summon_option_list[0] : selected_option;
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          Summon Options
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <CharacterSummonOptions 
            name="Choose"
            character={character}
            value={option}
            summon_option_list={summon_option_list}
            shared={shared}
            index
            onChange={setSelectedOption}
          />
        </Grid>
        { selected_option && spell &&
          <Grid
            size={{
              xs: 12
            }}>
            <DisplaySummonOption
              character={character}
              obj={selected_option}
              spell={spell}
              level={level}
            />
          </Grid>
        }
      </Grid>
    );
  }

  const summonSelected = (selected_option: SummonOption2) => {
    if (spell) {
      // debugger;
      const upgrades = character.summon_upgrade_features.filter(o => 
        o.creature_types.includes(selected_option.creature_type)
      );
      setProcessing(true);
      char_util.summonMinions(character, spell, level, selected_option, upgrades).then(() => {
        setProcessing(false);
        onChange(["Minions"]);
      });
    }
  }

  const viewSelected = () => {
    // Opens a modal with a viewable version of the statblock without actually summoning it
    setOpen(true);
  }

  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    const option = summon_option_list.length === 1 ? summon_option_list[0] : selected_option;
    let range_string = spell instanceof Attack ? "Self" : char_util.getRangeString({ char_int: character, spell, effect });
    if (hide_touch && (range_string === "Touch" || range_string === "Self")) {
      range_string = "";
    }
    return (
      <Grid className="centered"
        container spacing={0} direction="row">
        <Grid
          className="centered"
          size={{
            xs: 4
          }}>
          { range_string }{ extra_string !== "" ? (range_string !== "" ? ` / ${extra_string}` : extra_string) : "" }
        </Grid>
        <Grid
          size={{
            xs: 4
          }}>
          { summon_option_list.length !== 1 ?
            <CharacterSummonOptions 
              name="Choose"
              character={character}
              // potence={potence}
              value={option}
              summon_option_list={summon_option_list}
              shared={shared}
              onChange={setSelectedOption}
            />
          : option &&
            <>{ option.name }</>
          }
        </Grid>
        <Grid
          size={{
            xs: 4
          }}>
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 12,
                sm: 6
              }}>
              <DandDButtonBox 
                name="Summon"
                disabled={ !enabled || option === null || option === undefined || processing }
                onClick={() => {
                  if (option) {
                    summonSelected(option);
                  }
                }}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 6
              }}>
              <DandDButtonBox 
                name="View"
                disabled={ !enabled }
                onClick={() => {
                  viewSelected();
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        { renderExtras() }
      </Grid>
    );
  }
}
